module.exports = "\r\n<div class=\"title\">\r\n        {{maintitle}}\r\n    </div>\r\n\r\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/ultilities/office/office.component.html
// module id = ./src/app/ultilities/office/office.component.html
// module chunks = main